import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

export default function TileBanDialog({ open, message, onTryAgain, onClose }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("map.ban.dialogTitle")}</DialogTitle>
      <DialogContent>
        <Typography variant="body1">{message}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">
          {t("common.ok")}
        </Button>
        <Button onClick={onTryAgain} variant="contained" color="primary">
          {t("common.tryAgain")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
